import React from "react";
import { Link } from "react-router-dom";
import { ShieldCheck, FileBadge, Lock, Cpu, Network, BookMarked, Scale, ArrowRight } from "lucide-react";
import { SitePage, PageHead } from "./SiteChrome";

const TECH = [
  { I: Network, t: "The Bridge", d: "An event-driven layer that lets each platform contribute intelligence to — and receive intelligence from — the ecosystem, without tight coupling." },
  { I: Cpu, t: "Executive Intelligence", d: "An orchestration layer where specialised reasoning components evaluate decisions independently and synthesise explainable recommendations." },
  { I: BookMarked, t: "Institutional Memory", d: "A curated organisational asset. Knowledge is promoted only when it meets defined criteria — memory is never a raw activity log." },
  { I: Scale, t: "Explainable by design", d: "Every recommendation carries its evidence, confidence, and dissent. If reasoning cannot be shown, it does not ship." },
];

const SECURITY = [
  { I: ShieldCheck, t: "Designed for HIPAA-aligned deployment", d: "Architecture engineered around healthcare data-protection principles: encryption in transit and at rest, access controls, and audit trails." },
  { I: Lock, t: "Synthetic data during evaluation", d: "Beta and evaluation environments operate on synthetic data only. No patient information is used until formal agreements and safeguards are in place." },
  { I: FileBadge, t: "Patent Pending USPTO", d: "Provisional patents on file covering core reasoning and orchestration methods." },
  { I: Scale, t: "Human accountability preserved", d: "Automated outputs are decision support. Clinicians and administrators retain final authority, with documented override paths." },
];

export default function TrustPage() {
  return (
    <SitePage testId="trust-page">
      <PageHead
        label="Trust & Technology"
        title={<>Healthcare-grade. <span className="grad-text">By design.</span></>}
        lede="How CamelionAI is engineered — and the standards we hold ourselves to before any system touches real healthcare workflows."
      />

      <div className="sp-section-label">
        <div className="section-label"><span className="label-line" /> The technology</div>
      </div>
      <div className="trust-grid">
        {TECH.map(({ I, t, d }) => (
          <div className="trust-card" key={t}>
            <span className="trust-card-icon"><I size={20} /></span>
            <div>
              <div className="trust-card-title">{t}</div>
              <div className="trust-card-sub">{d}</div>
            </div>
          </div>
        ))}
      </div>

      <div className="sp-section-label">
        <div className="section-label"><span className="label-line" /> Security &amp; accountability</div>
      </div>
      <div className="trust-grid">
        {SECURITY.map(({ I, t, d }) => (
          <div className="trust-card" key={t}>
            <span className="trust-card-icon"><I size={20} /></span>
            <div>
              <div className="trust-card-title">{t}</div>
              <div className="trust-card-sub">{d}</div>
            </div>
          </div>
        ))}
      </div>

      <p className="sp-disclaimer" data-testid="trust-disclaimer">
        CamelionAI platforms provide decision support and workflow intelligence. They do not provide medical
        advice, diagnosis, or treatment, and final decisions always rest with qualified professionals.
        Compliance obligations depend on each organisation's deployment and agreements.
      </p>

      <div className="sp-cta-strip">
        <p>Questions about security, architecture, or deployment?</p>
        <Link to="/contact?type=professional" className="btn-primary sp-btn" data-testid="trust-contact-cta">
          Talk to us <ArrowRight size={15} />
        </Link>
      </div>
    </SitePage>
  );
}
